module.exports = __webpack_public_path__ + "img/rules_7.695b3c39.png";